import styled from 'styled-components';

export const StyledUserList = styled.div`
  font-family: ${(props): string => props.theme.fonts.body};
  font-size: ${(props): string => props.theme.fontSizes.pageDescription};
  min-height: inherit;

  .user-list__header {
    background-color: ${(props): string => props.theme.colors.lightGray};
    position: sticky;
    top: -62px;
    z-index: 97;
  }

  .user-list__header-content {
    max-width: 1056px;
    margin: auto;
    padding: 38px 24px 15px;

    .user-list__filter-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 24px;

      .user-list__action-buttons-wrapper {
        display: flex;
        align-self: end;

        .user-list__upload-users-btn {
          text-transform: uppercase;
          margin-right: 20px;

          svg {
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }
        }

        .user-list__invitation-btn {
          text-transform: uppercase;
        }
      }
    }
  }

  .user-list__title {
    font-size: ${(props): string => props.theme.fontSizes.pageTitle};
    color: ${(props): string => props.theme.colors.text};
    font-family: ${(props): string => props.theme.fonts.pageTitle};
    text-transform: uppercase;
    margin-bottom: 7px;
  }

  .user-list__filter {
    display: flex;
    justify-content: space-between;

    .user-list__select-wrapper {
      width: 230px;
    }

    .ant-select {
      width: 100%;

      .ant-select-selector {
        background-color: ${(props): string => props.theme.colors.white};
      }
    }
  }

  .user-list__filter-label {
    font-family: ${(props): string => props.theme.fonts.filterLabel};
    font-size: ${(props): string => props.theme.fontSizes.filterLabel};
    color: ${(props): string => props.theme.colors.text};
    text-transform: uppercase;
  }

  .user-list__select {
    width: 100%;
  }

  .user-list__filter-label {
    font-family: ${(props): string => props.theme.fonts.filterLabel};
    font-size: ${(props): string => props.theme.fontSizes.filterLabel};
    color: ${(props): string => props.theme.colors.text};
    text-transform: uppercase;
  }

  .user-list__body-content {
    max-width: 1056px;
    margin: 26px auto 0;
    padding: 0 24px;

    .user-list__search-input {
      margin: 0 0 24px 0;
      display: flex;
      width: 100%;
      flex-direction: row-reverse;

      .user-list__search-custom-input {
        width: 320px;

        .ant-input {
          height: 17px;
          width: 249px;
          font-size: 13px;
        }

        .ant-input-prefix svg {
          width: 18px;
          height: 18px;
          stroke-width: 30px;
          stroke: ${(props): string => props.theme.colors.white};
        }

        .ant-input-suffix {
          margin-right: 15px;
        }
      }
    }
  }

  .user-list__table {
    margin-bottom: 40px;

    .ant-table-tbody {
      .ant-table-row {
        cursor: pointer;
      }
    }
  }

  .user-list__user-status-icon {
    margin: 0 10px;
  }
`;
